import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import '../App.css';

function PrivacyPolicy() {
  const navigate = useNavigate();
  const updated = 'April 20, 2025';

  return (
    <div style={{ minHeight: '100vh', background: '#f8fafc' }}>
      <Helmet>
        <title>Privacy Policy | OfferLelo</title>
        <meta name="description" content="Read OfferLelo's Privacy Policy to understand how we collect, use, and protect your personal information." />
        <link rel="canonical" href="https://www.offerlelo.com/privacy-policy" />
        <meta name="robots" content="index, follow" />
      </Helmet>

      <header className="modern-header">
        <div className="header-logo" style={{ cursor: 'pointer' }} onClick={() => navigate('/')}>
          <img src="/logo.svg" alt="OfferLelo Logo" />
          <span className="header-logo-text">OfferLelo</span>
        </div>
        <div className="header-actions">
          <button className="admin-btn" onClick={() => navigate('/')}>← Home</button>
        </div>
      </header>

      <div style={{ maxWidth: 860, margin: '0 auto', padding: '48px 24px 64px' }}>
        <h1 style={{ fontSize: '2rem', fontWeight: 800, color: '#1e293b', marginBottom: 8 }}>Privacy Policy</h1>
        <p style={{ color: '#94a3b8', fontSize: '0.9rem', marginBottom: 40 }}>Last updated: {updated}</p>

        <div style={{ background: '#fff', borderRadius: 16, padding: '36px 40px', boxShadow: '0 4px 24px rgba(0,0,0,0.07)', lineHeight: 1.8, color: '#334155', fontSize: '1rem' }}>

          <Section title="1. Introduction">
            Welcome to <strong>OfferLelo</strong> ("we", "us", or "our"). We operate the website{' '}
            <a href="https://www.offerlelo.com" style={{ color: '#6366f1' }}>www.offerlelo.com</a> (the "Service").
            This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website.
            Please read this policy carefully. If you disagree with its terms, please discontinue use of the site.
          </Section>

          <Section title="2. Information We Collect">
            <p>We may collect information about you in the following ways:</p>
            <ul>
              <li><strong>Log Data:</strong> When you visit our site, our servers automatically record information including your IP address, browser type, pages visited, and time spent on pages.</li>
              <li><strong>Cookies:</strong> We use cookies and similar tracking technologies to track activity on our Service and hold certain information. You can instruct your browser to refuse all cookies or to indicate when a cookie is being sent.</li>
              <li><strong>Analytics:</strong> We may use third-party analytics tools (such as Google Analytics) to measure traffic and usage trends.</li>
            </ul>
            <p>We do <strong>not</strong> collect personally identifiable information (such as your name, email, or payment details) unless you voluntarily contact us.</p>
          </Section>

          <Section title="3. Google AdSense & Third-Party Advertising">
            <p>
              We use <strong>Google AdSense</strong> to serve advertisements on our website. Google AdSense uses cookies to serve ads based on your prior visits to our website or other websites on the internet.
            </p>
            <p>
              Google's use of advertising cookies enables it and its partners to serve ads to our users based on their visit to our site and/or other sites on the Internet.
              You may opt out of personalised advertising by visiting{' '}
              <a href="https://www.google.com/settings/ads" target="_blank" rel="noopener noreferrer" style={{ color: '#6366f1' }}>Google Ads Settings</a>.
            </p>
            <p>
              Third-party vendors, including Google, use cookies to serve ads based on a user's prior visits to our website.
              These third-party cookies are governed by the respective privacy policies of those third parties.
            </p>
          </Section>

          <Section title="4. Affiliate Links">
            <p>
              OfferLelo participates in affiliate marketing programs. This means we may earn a commission when you click on certain links and make a purchase — at <strong>no extra cost to you</strong>.
              We only recommend products and services we believe will add value to our readers.
            </p>
          </Section>

          <Section title="5. How We Use Your Information">
            <p>We use the information we collect to:</p>
            <ul>
              <li>Operate and improve our website</li>
              <li>Understand how visitors use our site (analytics)</li>
              <li>Display relevant advertisements via Google AdSense</li>
              <li>Respond to your inquiries when you contact us</li>
            </ul>
          </Section>

          <Section title="6. Cookies Policy">
            <p>Cookies are small text files placed on your device. We use:</p>
            <ul>
              <li><strong>Essential Cookies:</strong> Required for the website to function properly.</li>
              <li><strong>Analytics Cookies:</strong> Help us understand how visitors interact with our website.</li>
              <li><strong>Advertising Cookies:</strong> Used by Google AdSense to deliver personalised ads.</li>
            </ul>
            <p>You can control cookies through your browser settings. Disabling cookies may affect your experience on our site.</p>
          </Section>

          <Section title="7. Third-Party Links">
            <p>
              Our website contains links to third-party websites (retailers, affiliate partners). We have no control over the content, privacy policies, or practices of those sites and accept no responsibility for them.
              We encourage you to review the privacy policy of every site you visit.
            </p>
          </Section>

          <Section title="8. Children's Privacy">
            <p>
              Our Service is not directed to anyone under the age of 13. We do not knowingly collect personally identifiable information from children under 13.
              If you are a parent or guardian and believe your child has provided us with personal information, please contact us.
            </p>
          </Section>

          <Section title="9. Data Security">
            <p>
              We implement reasonable security measures to protect your information. However, no method of transmission over the Internet or method of electronic storage is 100% secure.
              While we strive to use commercially acceptable means to protect your information, we cannot guarantee its absolute security.
            </p>
          </Section>

          <Section title="10. Changes to This Policy">
            <p>
              We may update this Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page with an updated date.
              We encourage you to review this Privacy Policy periodically for any changes.
            </p>
          </Section>

          <Section title="11. Contact Us" last>
            <p>If you have any questions about this Privacy Policy, please contact us:</p>
            <p>
              📧 Email:{' '}
              <a href="mailto:offerleleo365@gmail.com" style={{ color: '#6366f1', fontWeight: 600 }}>
                offerleleo365@gmail.com
              </a>
            </p>
            <p>🌐 Website: <a href="https://www.offerlelo.com" style={{ color: '#6366f1' }}>www.offerlelo.com</a></p>
          </Section>
        </div>
      </div>

      <div style={{ background: '#1e1b4b', color: '#6366f1', textAlign: 'center', padding: '16px', fontSize: '0.82rem' }}>
        © {new Date().getFullYear()} OfferLelo ·{' '}
        <a href="mailto:offerleleo365@gmail.com" style={{ color: '#818cf8', textDecoration: 'none' }}>offerleleo365@gmail.com</a>
      </div>
    </div>
  );
}

function Section({ title, children, last }) {
  return (
    <div style={{ marginBottom: last ? 0 : 32 }}>
      <h2 style={{ fontSize: '1.15rem', fontWeight: 700, color: '#1e293b', marginBottom: 12, paddingBottom: 8, borderBottom: '1px solid #f1f5f9' }}>
        {title}
      </h2>
      {children}
    </div>
  );
}

export default PrivacyPolicy;
